import type { ReactNode } from 'react'
import type { CrmData } from '@/constants/crm'

import Sidebar from '@/components/generals/sidebar/sidebar'
import NoticeToast from '@/components/generals/notice-toast'
import InviteDialog from '@/components/generals/invite-dialog'
import CompanyDetail from '@/components/companies/detail/company-detail'
import Profile from '@/components/companies/profile/profile'
import NewCompanyDialog from '@/components/companies/new-company/new-company-dialog'
import CommandMenu from '@/components/companies/command-menu/command-menu'
import DealDialog from '@/components/deals/deal-dialog'
import ContactDialog from '@/components/contacts/contact-dialog'
import ContactDetail from '@/components/contacts/contact-detail'
import ActivityDialog from '@/components/activities/activity-dialog'
import SequenceDialog from '@/components/sequences/sequence-dialog'
import SequenceDetail from '@/components/sequences/sequence-detail'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { CrmStoreProvider } from '@/stores/crm-store-provider'

interface AppShellProps {
    data?: CrmData | null
    today: string
    title?: string
    description?: string
    children: ReactNode
}

export default function AppShell({ data, today, title, description, children }: AppShellProps) {
    return (
        <CrmStoreProvider data={data} today={today}>
            <Seo title={title} description={description} />

            <Layout>
                <Sidebar />
                <div className='flex min-h-0 min-w-0 flex-1 flex-col'>
                    {children}
                </div>
            </Layout>

            <CompanyDetail />
            <Profile />
            <ContactDetail />
            <SequenceDetail />
            <NewCompanyDialog />
            <DealDialog />
            <ContactDialog />
            <ActivityDialog />
            <SequenceDialog />
            <InviteDialog />
            <CommandMenu />
            <NoticeToast />
        </CrmStoreProvider>
    )
}
